import {
  Participation,
  ParticipationMutationOptions,
  ParticipationUpdateData,
  useParticipation,
} from '@app/api';
import { MeetingRating } from './MeetingRating';
import { CenteredModal, TitleWithIcon, useToast } from '@app/core';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  titleLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.marginBase * 2,
    marginTop: theme.marginBase * 2,
    paddingBottom: 0,
    border: 'none',
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  participation?: Participation;
  reportMutationOptions?: ParticipationMutationOptions;
  payMutationOptions?: ParticipationMutationOptions;
  onRescheduleClick?: () => any;
}

export const MeetingRatingModal = ({
  participation,
  isOpen,
  onRequestClose,
  onRescheduleClick,
  reportMutationOptions,
  payMutationOptions,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const toast = useToast();
  const { data: updatedParticipation } = useParticipation(participation?.id);

  const openRescheduleModal = useCallback(
    () => onRescheduleClick && onRescheduleClick(),
    [onRescheduleClick],
  );

  const reportMutationOptionsWithClose = {
    ...reportMutationOptions,
    onSuccess: (
      data: Participation,
      variables: Participation,
      context: Participation | ParticipationUpdateData | undefined,
    ) => {
      reportMutationOptions?.onSuccess?.(data, variables, context);
      toast.saved();
      onRequestClose();
    },
  };

  const payMutationOptionsWithClose = {
    ...payMutationOptions,
    onSuccess: (
      data: Participation,
      variables: Participation,
      context: Participation | ParticipationUpdateData | undefined,
    ) => {
      payMutationOptions?.onSuccess?.(data, variables, context);
      toast.saved();
      onRequestClose();
    },
  };

  if (
    (!participation && !updatedParticipation) ||
    updatedParticipation === undefined
  ) {
    return null;
  }

  return (
    <CenteredModal
      overflow
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={
        <TitleWithIcon
          icon="ri-star-line"
          iconColor="blue"
          title={t('sessions.details.monitoring.meetingRating.title')}
          className={classes.titleLine}
        />
      }
    >
      <MeetingRating
        participation={updatedParticipation}
        reschedule={openRescheduleModal}
        withoutTitle
        payMutationOptions={payMutationOptionsWithClose}
        reportMutationOptions={reportMutationOptionsWithClose}
      />
    </CenteredModal>
  );
};
